export const AppPermissions = {
  TECHNICALOFFICE: 'technical-office',
  CITYHALL: 'cityhall',
  COMPANY: 'company',
  XUNTA: 'xunta',
} as const;

export type ProfileRoles = (typeof AppPermissions)[keyof typeof AppPermissions];
export type PermissionsOperation = 'and' | 'or';
